import { Navigate } from "react-router-dom";

function ProtectedRouteAdmin({ children }) {
  const adminToken = localStorage.getItem("adminToken");

  if (!adminToken) {
    return <Navigate to="/manage/login" replace />;
  }

  return children;
}

export default ProtectedRouteAdmin;
